import { observer } from 'mobx-react-lite'
import { runInAction } from 'mobx'
import React, { useContext, useEffect, useState } from 'react'
import { BrowserRouter } from 'react-router-dom'
import AppRouter from './components/AppRouter'
import Cookie from './components/Cookie'
import Footer from './components/footer/Footer'
import Header from './components/header/header'
import NoodlesRain from './components/NoodlesRain/NoodlesRain'
import ResultModal from './components/UI/ResultModal/ResultModal'
import { checkActive } from './http/orderApi'
import { fetchHeaderAndFooter } from './http/settingsApi'
import { startPublicHeaderLoad } from './http/publicHeaderBootstrap'
import { AUTH_BOOTSTRAP_REJECTED, check, getСheckingUserOrder } from './http/userAPI'
import { Context } from './index'
import './styles/App.css'

const App = observer(() => {
	const { main, user, settings, basket, delivery } = useContext(Context)
	const [headerState, setHeaderState] = useState([])
	const [runLine, setRunLine] = useState(null)
	const [active, setActive] = useState(true)
	const [stateSearcht, setStateSearcht] = useState(false)
	const isAuth = user.isAuth

	useEffect(() => startPublicHeaderLoad(fetchHeaderAndFooter, ({menu, data}) => {
		setHeaderState(menu)
		setRunLine(data)
	}), [])

	useEffect(() => {
		let mounted = true
		let pixelListener = null
		const session = main.basketSession
		const attempt = session.startBootstrap()
		const attemptCurrent = () => mounted && session.isCurrent(attempt)
		const acceptedCurrent = (epoch, principalId) => mounted && basket.sessionEpoch === epoch &&
			basket._session?.principalId === principalId &&
			(principalId === null ? user.isAuth === false : user.isAuth === true && user.user?.id === principalId)
		checkActive().then((response) => {
			if (mounted && response) {
				setActive(response.active)
			}
		}).catch(() => {})

		window.dataLayer = window.dataLayer || []

		const accepted = (data) => {
			const epoch = basket.sessionEpoch
			const principalId = data ? data.id : null
			const current = () => acceptedCurrent(epoch, principalId)
			let favoriteJson = localStorage.getItem('favoriteStorage')
			if (!favoriteJson) {
				localStorage.setItem('favoriteStorage', '[]')
			} else {
				try { settings.setFavoriteArray(JSON.parse(favoriteJson)) } catch { settings.setFavoriteArray([]) }
			}

			if (!data) {
				settings.setActiveModalNonAuth(true)
			} else {
				getСheckingUserOrder(principalId).then((response) => {
					if (current() && response) {
						settings.setCheckingUserOrder(response.res)
					}
				}).catch(() => {})
				const identify = () => { if (current() && window.turboTarget) window.turboTarget.push({ UserID: principalId }) }
				if (window.turboTarget) identify()
				else { pixelListener = identify; document.addEventListener('generalPixelInited', pixelListener, { once: true }) }
			}
			session.refresh()
		}
		if (!attempt.hadCredential) {
			if (attemptCurrent() && session.acceptGuest(attempt)) accepted(null)
			else if (attemptCurrent()) runInAction(() => session.failAuth(attempt))
		} else {
			check({ canCommitToken: attemptCurrent, commitContext: attempt }).then(data => {
				if (!attemptCurrent()) return
				if (data === AUTH_BOOTSTRAP_REJECTED && session.rejectSavedCredential(attempt)) accepted(null)
				else if (session.acceptAuth(attempt, data)) accepted(data)
				else runInAction(() => session.failAuth(attempt))
			}).catch(() => { if (attemptCurrent()) runInAction(() => session.failAuth(attempt)) })
		}
		return () => {
			mounted = false
			session.cancelAttempt(attempt)
			if (pixelListener) document.removeEventListener('generalPixelInited', pixelListener)
		}
	}, [main, settings, basket, user])

	useEffect(() => {
		const addresses = delivery.myAddresses

		/*if (isAuth) {
			for (const address of addresses) {
				
				addAddressMutation.mutate(address, {
					onError: (error) => console.error('Ошибка при добавлении адреса:', error),
				})
			}
		}*/
	}, [isAuth])

	return (
		<div className='App'>
			{window.location.pathname.includes('catalog/collab/youwannarollton') && <NoodlesRain />}
			{active ? (
				<BrowserRouter>
					<Header
						headerMenu={headerState}
						runline={runLine}
						stateSearcht={stateSearcht}
						setStateSearcht={setStateSearcht}
					/>
					<AppRouter />
					<ResultModal controllClass={settings.resultModalActive ? 'active' : ''} />
					<Footer />
				</BrowserRouter>
			) : (
				'Отключено.'
			)}
			<Cookie />
		</div>
	)
})

export default App
